<script setup>
  // import OverlayComponent from "@/components/OverlayComponent.vue";

  import OverlayComponent from "@/components/OverlayComponent.vue";

  const props = defineProps({
    bgImage: {
      default: '/images/nkruma.jpg',
      type: String
    },
    heroImage: {
      default: '/images/lady2.png',
      type: String
    },
    height: {
      default: '30vh',
      type: String
    },
    isPostHeader: {
      default: false,
      type: Boolean,
    },
    isHomePage: {
      default: false,
      type: Boolean
    }
  })
  // link = 'https://siviaggia.it/wp-content/uploads/sites/2/2017/09/capitale-del-ghana-accra-monumenti.jpg'
</script>

<template>
  <div
    class="header relative welcome mb-3 bg-transparent overflow-x-hidden"
    :style="[
      props.isPostHeader ? 'min-height: auto': 'min-height: 50vh',
      isHomePage ?
        'background: aquamarine'
        : 'background-image: url(\'' + props.bgImage + '\');' +
          ' background-size: cover;' +
          ' background-position: center;' +
          ' background-attachment: scroll;'
    ]"
  >
    <div
      class="relative overflow-hidden"
      :style="[props.isPostHeader ? 'min-height: 30vh': 'min-height: 50vh']"
    >
      <div class="absolute top-0 left-0 w-full h-full z-0 blur" />
      <OverlayComponent
        v-if="!props.isHomePage"
        style="z-index: 0;"
      />
      <div
        :class="[props.isPostHeader ? 'h-fit' : 'container', 'relative grid grid-cols-1 mx-auto z-10']"
        style="min-height: inherit"
      >
        <slot name="content" />
      </div>
      <div
        v-if="!props.isPostHeader"
        class="absolute min-w-full min-h-full min-h-vh position-image mt-0 z-0 top-0"
        :style="[props.isPostHeader ? 'height: 30vh' : 'height: 50vh;']"
      >
        <img
          :src="props.heroImage"
          alt=""
          class="h-full image-art mt-28 md:mt-38 xl:mt-32 overflow-y-hidden"
        >
      </div>
      <div
        v-if="!props.isPostHeader"
        class="relative -mt-20 lg:-mt-32 xl:-mt-64 z-0"
      >
        <img
          src="/images/wave.svg"
          alt="path"
        >
      </div>
    </div>
    <!--    <span class="absolute top-0 left-0 w-full h-full z-0 blur" />-->
  </div>
</template>

<style scoped>
.blur {
  backdrop-filter: blur(3px);
  background: rgba(200, 200, 200, 0.2);
}
.position-image {
  width: 100%;
  left: 18%;
  z-index: 0;
}
@media (min-width:720px) {
  .position-image {
    left: 15%;
    z-index: 0;
  }
}
@media (min-width:1024px) {
  .position-image {
    left: 15%;
    z-index: 0;
  }
}
@media (min-width:1282px) {
  .position-image {
    left: 30%;
    z-index: 0;
  }
}
@media (min-width:1444px) {
  .position-image {
    left: 40%;
    z-index: 0;
  }
}

</style>
